module.exports = __webpack_public_path__ + "img/electric_reserved_selected.47727c87.svg";